<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             title="质检"
             @open="open"
             @closed="closed"
             width="700px">
    <div style="margin: 0 30px 0 30px">
      <el-form label-position="right" label-width="100px" :model="request" :rules="rules" ref="request">
        <div style="display: flex">
          <div style="flex-grow: 1">
            <el-form-item label="工单号">
              <label class="value">{{work.extraId || work.id}}</label>
            </el-form-item>
            <el-form-item label="车牌号">
              <label class="value">{{work.carNo | carNo}}</label>
            </el-form-item>
            <el-form-item label="验收结果" style="flex-grow: 1">
              <el-radio-group v-model="request.qualified" @change="qualifiedChange">
                <el-radio :label="false">不合格</el-radio>
                <el-radio :label="true">合格</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div style="flex-grow: 1">
            <el-form-item label-width="100px" label="预计完成时间">
              <label class="value">{{work.enterTime}}</label>
            </el-form-item>
            <el-form-item label="车辆型号">
              <label class="value">{{work.brandName}} / {{work.model}}</label>
            </el-form-item>
            <el-form-item :label="request.qualified ? '下个工序': '返工工序'"
                          :prop="!request.qualified ? 'prevProcedureId' : 'nextProcedureId'">
              <remote-select v-if="!request.qualified"
                             v-model="request.prevProcedureId"
                             :options="dispatchProcedureList"
                             key="prev">
              </remote-select>
              <remote-select v-else select-first
                             class-name="ActiveProcedureAfterQuality"
                             v-model="request.nextProcedureId"
                             key="next">
              </remote-select>
            </el-form-item>
          </div>
        </div>
      </el-form>

      <el-form label-position="right" label-width="100px">
        <el-form-item label="备注">
          <el-input type="textarea" v-model="request.remarks" :rows="4" maxlength="200" resize="none"
                    :placeholder="request.qualified ? '' : '返工原因描述'"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button type="primary" @click="confirm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { dispatchWorkProcedures, qualityInspect } from '@/utils/request'
  import RemoteSelect from '@/components/selector/RemoteSelect'

  export default {
    name: 'QualityInspectDialog',
    components: {
      RemoteSelect
    },
    props: {
      work: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        loading: false,
        request: {
          workId: null,
          qualified: true,
          prevProcedureId: null,
          nextProcedureId: null,
          remarks: null
        },
        dispatchProcedureList: [],
        nextProcedureList: [],
        rules: {
          prevProcedureId: [
            {
              required: true,
              message: '请选择返工工序',
              trigger: 'change'
            }
          ]
        }
      }
    },
    methods: {
      open () {
        this.loading = true
        dispatchWorkProcedures(this.work.id).then(response => {
          this.dispatchProcedureList = response.data
        }).finally(() => {
          this.loading = false
        })
      },
      closed () {
        this.request.workId = null
        this.request.qualified = true
        this.request.prevProcedureId = null
        this.request.nextProcedureId = null
        this.request.remarks = null
        this.dispatchProcedureList = []
        this.$refs.request.resetFields()
      },
      cancel () {
        this.hide()
      },
      confirm () {
        this.$refs.request.validate(valid => {
          if (!valid) return

          this.request.workId = this.work.id
          this.work.loading = true
          qualityInspect(this.$_.cloneDeep(this.request))
            .then(() => this.hide())
            .catch(() => {
              this.work.loading = false
            })
        })
      },
      hide () {
        this.$emit('update:visible', false)
      },
      qualifiedChange () {
        this.$refs.request.resetFields()
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-radio {
    margin-right: 10px;
  }
</style>
